import crudmaker from '@/store/crudmaker'
import { apiClient } from '@/client'
import merge from 'deepmerge'
import { compactAndFilter } from '@/utils'

const module = 'districts'
let doc = {
  list: {
    name: 'Districts',
    headers: [
      { label: 'Nom', value: 'name' },
      { label: 'Ville', value: 'city.name' },
      { label: 'Région', value: 'city.region.name' },
    ],
    actions: [
      { icon: 'add', isFlat: false, scope: ['districts.create'], dispatch: `${module}/openForm` },
      { icon: 'search', isFlat: true, dispatch: `${module}/openSearch` },
    ],
    dataActions: [
      { icon: 'visibility', dispatch: `${module}/goTo` },
      { icon: 'pie_chart', context: {field: 'district_id'}, dispatch: `tenancy/getTenancy` },
    ],
    selectActions: [
      {
        label: 'Supprimer',
        icon: 'delete',
        scope: ['districts.delete'],
        dispatch: `${module}/batchDelete`,
        context: {confirm: true},
        menu: true,
      },
      {
        label: 'Occupation',
        icon: 'pie_chart',
        dispatch: `tenancy/getMultiTenancy`,
        context: {field: 'district_id'},
      },
    ],
    search: [
      { label: 'Nom', type: 'text', name: 'name' },
      { label: 'Ville', type: 'multilist', name: 'city_id', from: 'name', source: 'cities' },
      { label: 'Région', type: 'multilist', name: 'region_id', from: 'name', source: 'regions' },
    ],
  },

  form: {
    name: 'District',
    hasPhoto: true,
    actions: [
      { icon: 'save', filter: {edit: true}, scope: ['districts.update'], dispatch: `${module}/update` },
      {
        icon: 'delete',
        scope: ['districts.delete'],
        isFlat: true,
        dispatch: `${module}/delete`,
        context: { confirm: true },
      },
    ],
    fields: [
      { label: 'Nom', type: 'text', name: 'name' },
      { label: 'Region', type: 'list', from: 'name', name: 'city.region_id', source: 'regions' },
      {
        label: 'Ville',
        type: 'list',
        source: 'cities',
        from: 'name',
        name: 'city_id',
        cascade: { target: 'city.region_id', value: 'region_id' },
      },
    ],
    relations: [
      {
        name: 'Panneaux',
        source: 'boards',
        headers: [
          { label: 'Type', value: 'board_type.name' },
          { label: 'Adresse', value: 'adress' },
          { label: 'Statut', value: 'status.name' },
        ],
        dispatch: 'getBoards',
        dataActions: [
          { icon: 'visibility', isFlat: false, dispatch: `boards/goTo` },
        ],
      },
    ],
  },

  params: {
    fetchAll: {include: 'city.region'},
    fetchOne: {include: 'city.region'},
  },
}

const base = crudmaker(module, apiClient, doc)

const custom = {
  actions: {
    getBoards: ({ commit }, payload) => {
      const { context, data } = payload
      commit('boards/LIST_REQUEST', payload, {root: true})
      let compacted = compactAndFilter(data)
      let params = {
        ...compacted,
        district_id: context.id,
        include: 'board_type,status',
      }
      apiClient.fetchCustom('boards', `boards`, params)
        .then(data => {
          commit('boards/LIST_SUCCESS', data, {root: true})
        })
        .catch(error => {
          commit('boards/LIST_ERROR', error, {root: true})
        })
    },
  },
}

export default merge(base, custom)
